(()=>{
    var D = Object.create, d = Object.defineProperty, P = Object.getPrototypeOf, p = Object.prototype.hasOwnProperty, q = Object.getOwnPropertyNames, E = Object.getOwnPropertyDescriptor;
    var Q = (t)=>d(t, "__esModule", {
            value: !0
        });
    var V = (t, n)=>()=>(n || t((n = {
                exports: {}
            }).exports, n), n.exports);
    var W = (t, n, s)=>{
        if (n && typeof n == "object" || typeof n == "function") for (let c of q(n))!p.call(t, c) && c !== "default" && d(t, c, {
            get: ()=>n[c],
            enumerable: !(s = E(n, c)) || s.enumerable
        });
        return t;
    }, j = (t)=>W(Q(d(t != null ? D(P(t)) : {}, "default", t && t.__esModule && "default" in t ? {
            get: ()=>t.default,
            enumerable: !0
        } : {
            value: t,
            enumerable: !0
        })), t);
    var g = V((H, m)=>{
        function v(t, n, s) {
            let c = document.createElement("span");
            c.innerHTML = s.cursor || "_", c.style = `
  color: currentColor; 
  position: relative; 
  width: 1ch;
  `, c.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: s.cursorSpeed || 400,
                iterations: Infinity,
                direction: "alternate",
                easing: "ease-in-out"
            });
            let l = (e, r, { cursor: a })=>{
                e.innerText = r, e.appendChild(c);
            }, w = (e, r, a)=>new Promise((i)=>{
                    let u = a.speed * (a.speedVariation ? Math.random() * a.speedVariation : 1);
                    setTimeout(()=>(l(e, r, a), i()), u);
                }), C = (e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789")=>{
                let r = [
                    ...e
                ];
                return [
                    ...Array(1)
                ].map((a)=>r[Math.random() * r.length | 0]).join``;
            }, h = async (e, r, a, i)=>new Promise(async (u)=>{
                    let y = r.split("");
                    if (a === "write") for(let o = 0; o <= y.length; o++){
                        if (!!i.errorQuota && Math.random() <= i.errorQuota) {
                            let T = C(i.errorCharacterMap);
                            await w(e, r.substr(0, o - 1) + T, i), await w(e, r.substr(0, o - 1), i);
                        }
                        await w(e, r.substr(0, o), i);
                    }
                    if (a === "delete") {
                        l(e, r, i);
                        for(let o = y.length; o >= 0; o--)await w(e, r.substr(0, o), i);
                    }
                    return u();
                });
            function* M(e, r, a) {
                for(let i = 0; i < r.length; i++)yield ()=>h(e, r[i], "write", a), (i + 1 < r.length || a.loop) && (yield ()=>h(e, r[i], "delete", a));
            }
            let A = (e)=>new Promise((r)=>setTimeout(()=>r(), e)), f = async (e, r, a)=>{
                let i = typeof e == "string" ? document.querySelector(e) : e;
                for (let u of M(i, r, a))await u(), await A(a.timeout);
                if (a.loop) return f(e, r, a);
            };
            f(t, n, s);
        }
        m.exports = v;
    });
    var b = j(g());
    window.writeAndDelete = b.default;
})();

//# sourceMappingURL=index.850f5b52.js.map
